import { render, staticRenderFns } from "./ShowResumos.vue?vue&type=template&id=3f76e941&lang=pug&"
import script from "./ShowResumos.vue?vue&type=script&lang=js&"
export * from "./ShowResumos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports